// ─── Module « finance » (@mop/feature-finance) ───────────────────
// Budget porté de MoPCal (cf. MODELE-DONNEES.md § Budget & finances).
// Socle : POSTES budgétaires + OPÉRATIONS (dépense/revenu, payé/provision) +
// récapitulatif des parts et « qui doit à qui » avec remboursement.
export { FONCTIONS_FINANCE } from './fonctions';

// Écrans de l'app My Finance.
export { default as EcranFinances } from './EcranFinances';   // enveloppes + opérations
export { default as EcranMois } from './EcranMois';           // prévu vs réalisé
export { default as EcranComptes } from './EcranComptes';     // comptes et soldes
export { default as EcranCompte } from './EcranCompte';       // relevé d'un compte, mois par mois
export { default as EcranEnveloppe } from './EcranEnveloppe'; // plan d'une enveloppe, mois par mois
export { default as EcranConfigBudget } from './EcranConfigBudget'; // configuration des prévisions
export { default as EcranProjection } from './EcranProjection';     // mois à venir, solde cumulé
export { default as VueMois } from './VueMois';
export { default as FicheOccurrence } from './FicheOccurrence';
// `FeuilleRattacher` (liste plate) est DÉBRANCHÉE depuis le 16/08 : la
// multi-sélection en arbre la remplace, depuis le Suivi comme depuis les
// Comptes. Le fichier reste, plus exporté.
export { default as FeuilleRattacherLignes } from './FeuilleRattacherLignes';
export { default as FeuilleFiltresMois } from './FeuilleFiltresMois';
export { default as FeuilleFiltresCompte } from './FeuilleFiltresCompte';
export { default as FeuilleRattachement } from './FeuilleRattachement';
export { default as SectionCategories } from './SectionCategories';
export { default as FeuilleArbreEnveloppes } from './FeuilleArbreEnveloppes';
export { default as FeuilleRattacherOperations } from './FeuilleRattacherOperations';
export { default as FeuilleFiltresRattachement } from './FeuilleFiltresRattachement';
export { default as FicheOperation } from './FicheOperation';
export { default as FicheLignePrevue } from './FicheLignePrevue';
export {
  TRIS, filtrerOccurrences, filtrerImprevus,
  TRIS_OPERATIONS, filtrerOperations, nbFiltresReleve,
  TRIS_LIGNES, filtrerPlan,
} from './services/filtres';
export { TYPES_COMPTE, ecouterComptes, creerCompte, modifierCompte, supprimerCompte, soldeCompte, emojiCompte, compteParAcctid } from './services/comptes';
// Rattachements estimé ↔ réel : calculs PURS + accès Firestore.
export {
  EPSILON, rattachementsDeDepense, rattachementsDOccurrence, repartitionDepense,
  estImprevue, reelDOccurrence, indexerReel, verifierRattachement, montantParDefaut,
} from './services/repartition';
export {
  ecouterRattachements, rattacher, modifierRattachement, detacher, detacherTousDe,
} from './services/rattachements';

// Relevé d'un compte : calculs PURS (solde borné, totaux, navigation de mois).
export {
  releveDuMois, operationsDuCompte, totauxReleve, soldeCompteA, soldeFinDeMois,
  moisAvecOperations, moisVoisinAvecOperations, dateOp,
} from './services/releveCompte';
export { detecterTransferts } from './services/transferts';
export { motifsConnus, proposerOperations, proposerOccurrences, preselection } from './services/propositions';
export { ETATS, etatOperation, enveloppesDeOperation, grouperParEnveloppe, compterEtats } from './services/etatRattachement';
export {
  FILTRES_DEFAUT, filtrerCandidates, trierCandidates, TRIS_RATTACHEMENT,
  selectionInitiale, diffSelection, moisParDefaut, horsPlage, nbFiltresActifsRattachement,
} from './services/selectionOperations';
export { pourcentage, calculerPart, repartitionExacte } from './services/repartition';
export { verifierCoherence, fin4DuNom, resumeReleve } from './services/coherenceImport';
export { default as FeuilleCompte } from './FeuilleCompte';
export { default as FeuilleImport } from './FeuilleImport';

// Prévu vs réalisé : moteur d'occurrences (pur) + lignes prévues (Firestore).
export {
  occurrencesDuMois, imprevusDuMois, totauxMois, estDue, montantPrevu,
  decalerMois, moisEntre, moisImputation, internesDuMois,
  lignesDeBudget, prevuDuMoisParBudget, raisonNonDue, nonDuesDuMois, projectionMensuelle,
} from './services/occurrences';
export {
  FREQUENCES, ecouterLignes, creerLigne, modifierLigne, supprimerLigne,
  ecouterExceptions, definirException, retirerException,
  rattacherActual, detacherActual,
} from './services/lignes';
// Crédit amortissable (17/08) : port de MoPCal, cf. services/credit.js.
export {
  normaliserCredit, calculerCredit, echeancierCredit,
  estDueCredit, montantPrevuCredit, raisonNonDueCredit,
} from './services/credit';
export { default as SectionCredit } from './SectionCredit';

// Import bancaire : lecture de relevé (pur) + analyse/application (Firestore).
export {
  decoderReleve, detecterFormat, parserReleve, parseOFX, parseCSV, motifDeLibelle,
} from './services/releveBancaire';
// Rapprochement d'une opération avec une ligne PRÉVUE (calcul pur, testable).
export { meilleureLigne, scoreOccurrence, motsCommuns } from './services/rapprochementLignes';
export {
  analyserOperations, appliquerImport, enregistrerRegleImport, ecouterReglesImport,
} from './services/import';

// Calculs purs (réutilisables par les vues à venir : synthèses, projection…).
export {
  formatEuro, dateEffective, moisDe, normaliserPayeurs, totalPourcentages,
  recapBudget, soldesPersonnes, calculerDettes, totalBudget,
} from './services/calculs';

// Référentiels (catégories, moyens de paiement, emojis de poste).
export {
  CATEGORIES, CATEGORIES_SAISIE, TYPES_PAIEMENT, EMOJIS_BUDGET,
  emojiCategorie, cleCategorie, clePaiement,
} from './data/categories';
